// @ts-nocheck
/* eslint-disable */

import React from 'react';
import ViewEntity from '../../components/CRUD/ViewEntity';

const ViewBanks = () => {
  return (
    <ViewEntity
      pageTitle="BankInfo"
      fetchApiUrl="/api/v1/web_portal/settlements/banks/:id"
      fetchApiMethod="GET"
      dataPath="data.data"
      fields={[
        {
          name: 'bank_name_en',
          labelKey: 'BankNameEn',
          type: 'text',
        },
        {
          name: 'bank_name_ar',
          labelKey: 'BankNameAr',
          type: 'text',
        },
        {
          name: 'swift_code',
          labelKey: 'SwiftCode',
          type: 'text',
        },
        {
          name: 'created_at',
          labelKey: 'CreatedAt',
          type: 'date',
        },
        {
          name: 'updated_at',
          labelKey: 'UpdatedAt',
          type: 'date',
        },
      ]}
      editUrl="/settlements/Banks/:id/edit"
      deleteApiUrl="/api/v1/web_portal/settlements/banks/:id"
      deleteApiMethod="DELETE"
      backUrl="/settlements/Banks/"
      backButtonLabel="BackToBanks"
      buildTitle={(data, additionalData, intl) => {
        const currentLanguageCode = localStorage.getItem("EASY_MOBILITY_LANGUAGE") || 'en-us';
        return currentLanguageCode === 'en-us' ? data.bank_name_en : data.bank_name_ar;
      }}
      buildDeleteConfirmMessage={(data, additionalData, currentLanguageCode, intl) => {
        const bankName = currentLanguageCode === 'en-us' ? data.bank_name_en : data.bank_name_ar;
        return currentLanguageCode === 'en-us'
          ? `Are You Sure You Want To Delete ${bankName}?`
          : `هل أنت متأكد انك تريد حذف ${bankName}؟`;
      }}
      showEditButton={true}
      showDeleteButton={true}
      subsystemName="Banks"
    />
  );
};

export default ViewBanks;
